import React from "react";
import { Link } from "react-router-dom";
import useLiveTournamentNavigation, { useCachedFounderSession } from "../hooks/useLiveTournamentNavigation";

export default function LiveTournamentHomeBanner() {
  const isFounder = useCachedFounderSession();
  const liveTournament = useLiveTournamentNavigation({ includeTestMode: isFounder });

  if (!liveTournament) return null;

  const { tournament, isTest, detailsPath, hubPath } = liveTournament;
  const eventName = tournament?.name || "GAStreaming Tournament";
  const eventFormat = [tournament?.game, tournament?.mode].filter(Boolean).join(" • ");

  return (
    <section
      style={{
        margin: "0 0 24px",
        padding: "18px 20px",
        borderRadius: 18,
        border: isTest
          ? "1px solid rgba(196,128,255,.52)"
          : "1px solid rgba(255,70,70,.58)",
        background: isTest
          ? "linear-gradient(135deg,rgba(82,30,122,.78),rgba(18,9,29,.94))"
          : "linear-gradient(135deg,rgba(170,5,12,.78),rgba(18,7,9,.95))",
        boxShadow: isTest
          ? "0 18px 48px rgba(88,22,130,.28)"
          : "0 18px 48px rgba(180,0,10,.28)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              color: isTest ? "#e4b8ff" : "#ffb1b1",
              fontSize: 12,
              fontWeight: 1000,
              letterSpacing: 1.6,
            }}
          >
            {isTest ? "🧪 FOUNDER TEST TOURNAMENT" : "🔴 TOURNAMENT LIVE NOW"}
          </div>
          <h2 style={{ margin: "6px 0 5px", color: "#fff", fontSize: "clamp(22px,3vw,32px)" }}>
            {eventName}
          </h2>
          <div style={{ color: "rgba(255,255,255,.72)", fontSize: 14, lineHeight: 1.5 }}>
            {eventFormat || "GAStreaming tournament"}
          </div>
          {isTest ? (
            <div style={{ marginTop: 7, color: "rgba(255,255,255,.62)", fontSize: 12 }}>
              Visible only to the Founder while simulator mode is active.
            </div>
          ) : null}
        </div>

        <div style={{ display: "flex", gap: 9, flexWrap: "wrap" }}>
          {isTest ? (
            <>
              <Link to={detailsPath} style={primaryButton(true)}>
                RETURN TO TEST TOURNAMENT →
              </Link>
              <Link to={hubPath} style={secondaryButton}>
                OPEN TEST LIVE HUB
              </Link>
            </>
          ) : (
            <>
              <Link to={hubPath} style={primaryButton(false)}>
                WATCH LIVE HUB →
              </Link>
              <Link to={detailsPath} style={secondaryButton}>
                VIEW TOURNAMENT / BRACKET
              </Link>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

function primaryButton(testMode) {
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 42,
    padding: "10px 14px",
    borderRadius: 12,
    textDecoration: "none",
    color: "#fff",
    fontWeight: 1000,
    fontSize: 12,
    letterSpacing: .3,
    border: testMode
      ? "1px solid rgba(218,166,255,.6)"
      : "1px solid rgba(255,125,125,.7)",
    background: testMode
      ? "linear-gradient(135deg,#8b3bc2,#541977)"
      : "linear-gradient(135deg,#ff3030,#a90000)",
    boxShadow: testMode
      ? "0 10px 24px rgba(118,43,164,.3)"
      : "0 10px 24px rgba(200,0,0,.3)",
  };
}

const secondaryButton = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 42,
  padding: "10px 14px",
  borderRadius: 12,
  textDecoration: "none",
  color: "rgba(255,255,255,.9)",
  fontWeight: 900,
  fontSize: 12,
  border: "1px solid rgba(255,255,255,.17)",
  background: "rgba(255,255,255,.07)",
};
